var scope_0 = require('/Users/remicarton/repo/carton.pm/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aa4bf2e7d4f639441be40044aa088b23.js').default;
var scope_1 = require('/Users/remicarton/repo/carton.pm/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/Users/remicarton/repo/carton.pm/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f7d552029bf354c6b6fda20786c226d6.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    